import type { OnInit } from '@angular/core';
import { Component, inject, Input } from '@angular/core';
import { ReiReferralService } from '@core-mkt/services/rei-referral/rei-referral.service';
import type { CarouselItem } from './study-plan-builder.models';
import { ProductBuilderData } from './study-plan-builder.models';
import { ProductFormComponent } from './product-form/product-form.component';
import { SliderComponent } from './slider/slider.component';
import { WysiwygContentComponent } from './wysiwyg-content/wysiwyg-content.component';

@Component({
  selector: 'study-plan-builder',
  templateUrl: './study-plan-builder.component.html',
  standalone: true,
  imports: [ProductFormComponent, SliderComponent, WysiwygContentComponent],
})
export class StudyPlanBuilderComponent implements OnInit {
  @Input() data: ProductBuilderData;
  hasCarousel = false;
  hasWysiwygContent = false;
  hasProductBuilderForm = false;
  carouselData: CarouselItem[];
  wysiwygContent: string;

  private readonly reiReferralService = inject(ReiReferralService);

  ngOnInit(): void {
    const isReiReferred = this.reiReferralService.isReiReferred();
    if (this.data.carousel && this.data.carousel.length > 0) {
      this.carouselData = this.data.carousel;
      this.hasCarousel = true;
    } else if (this.data.imageCarousel?.length > 0) {
      this.carouselData = this.data.imageCarousel;
      this.hasCarousel = true;
    }
    if (this.data.wysiwygContent && this.data.wysiwygContent !== null && this.data.wysiwygContent?.length > 0) {
      this.hasWysiwygContent = true;
      this.wysiwygContent = this.data.wysiwygContent;
    } else if (this.data.wysiwygContent !== null && this.data.wysiwygContent?.length > 0) {
      this.wysiwygContent = this.data.wysiwygContent;
    }
    if (isReiReferred && this.wysiwygContent) {
      const eyebrow = `<span class="inline-flex items-center gap-3 mb-4">
        <img src="${this.reiReferralService.logoSrcDark}" style="height: 2em; width: auto;" />
        <span>${this.reiReferralService.eyebrowLabel}</span>
      </span>`;
      this.wysiwygContent = eyebrow + this.wysiwygContent;
    }
    this.hasProductBuilderForm = this.data.productBuilder?.length > 0;
  }
}
